import { render } from "./RiepilogoPresenze.vue?vue&type=template&id=1d076c00&scoped=true&ts=true"
import script from "./RiepilogoPresenze.vue?vue&type=script&lang=ts"
export * from "./RiepilogoPresenze.vue?vue&type=script&lang=ts"

import "./RiepilogoPresenze.vue?vue&type=style&index=0&id=1d076c00&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1768301730385742645/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d076c00"]])

export default __exports__